import styles from './index.module.scss';

const DemoBadge = () => {
    return (
        (<div className={styles.demoBadge} data-palette="DemoBadge">
            <span>Demo</span>
        </div>)
    );
}

export default DemoBadge;
